module.exports = __webpack_public_path__ + "settings.svg?1793698113381";